module.exports = __webpack_public_path__ + "front/img/edm-banner.eac40d33.png";